<template>
    <div class="container-fluid">
        <WelcomeComponent />

        <h2 class="mt-5">Featured Girls</h2>

        <AdsComponent :advertisements="topAds" />

        <h2 class="mt-5">New Girls</h2>

        <AdsComponent :advertisements="newAds" />

        <h2 class="mt-5">All Girls</h2>

        <AdsComponent :advertisements="advertisements" />

        <BlogComponent />

        <PartnerComponent />
    </div>
</template>

<script>
    import AdsComponent from "../components/AdsComponent";
    import BlogComponent from "../components/BlogComponent";
    import PartnerComponent from "@/components/PartnerComponent.vue";
    import WelcomeComponent from "@/components/WelcomeComponent.vue";
    export default {
        name: 'Home',
        components: {WelcomeComponent, PartnerComponent, BlogComponent, AdsComponent},
        metaInfo: {
          title: 'Escort Budapest'
        },
        data() {
            return {
                topAds: [],
                newAds: [],
                advertisements: [],
                domain: '',
            }
        },
        created() {
            window.scrollTo(0,0);
            this.fetchTop()
            this.fetchNew()
            this.fetchData()

        },
        methods: {
            fetchData() {
                this.$http.get(`${process.env.VUE_APP_API_URL}/advertisements`)
                    .then((response) => {
                        this.advertisements = response.data;
                    })
            },
            fetchTop() {
                this.$http.get(`${process.env.VUE_APP_API_URL}/advertisements/top`)
                    .then((response) => {
                        this.topAds = response.data;
                    })
            },
            fetchNew() {
                this.$http.get(`${process.env.VUE_APP_API_URL}/advertisements/new`)
                    .then((response) => {
                        this.newAds = response.data;
                    })
            }
        }
    }
</script>
